import { MDXLayout } from "@/shared/components/MDX/MDXLayout";
import Content from "../../help/production-orders.mdx";

export function ProductionOrdersHelpPage() {
  return (
    <MDXLayout>
      <Content />
    </MDXLayout>
  );
}
